import { eEstadoSede } from "../common/enumModel";
import { ISedeModel } from "../interfaces/sedes/ISedeModel";

export class SedeModel implements ISedeModel {
    
    idSede : number;
    nombre : string;
    idEstado: eEstadoSede;
    estado: string;
    nombreLenel: string;
    zonaAcceso: string;
    selectedCompanias: number[];
    nombresCompanias: string;
    
    constructor(){
        this.idSede = 0;
        this.nombre = '';
        this.idEstado = eEstadoSede.ACTIVO;
        this.estado = '';
        this.nombreLenel = '';
        this.zonaAcceso = '';
        this.selectedCompanias = [];
        this.nombresCompanias ='';
    }
}